export default __webpack_public_path__ + "static/doodle-arrow-566c09329708ead8e0adf6364fe7bdf5.gif";